'use strict';

module.exports = [
  '$provide',
  PopupServiceDecorator];

function PopupServiceDecorator($provide) {
  $provide.decorator('$popup', [
    '$delegate',
    '$ionicPopup',
    decorateService]);

  function decorateService($delegate, $ionicPopup) {
    $delegate.show = $ionicPopup.show;
    $delegate.alert = $ionicPopup.alert;
    $delegate.confirm = $ionicPopup.confirm;
    $delegate.prompt = $ionicPopup.prompt;

    return $delegate;
  }
}


// WEBPACK FOOTER //
// ./src/js/core-components-implementation/popup/PopupServiceImpl.js